
import request from '@/utils/request'; // 导入配置好的 axios 实例
// 仪器管理模块的所有接口，统一导出
export const IMG_BASE_URL = '/api/upload';
// export const IMG_BASE_URL = 'http://127.0.0.1:8081/upload';
export const DOWNLOAD_BASE_URL ='http://120.53.117.172:8081';
// export const DOWNLOAD_BASE_URL ='http://127.0.0.1:8081';
export const IMG_GET_URL = '/api';
export const PLATFORM_TITLE = '本溪高新区科技创新综合服务平台';
export const tech_demand_options = [
    { value: '优质粮油生产和食品制造' },
    { value: '新能源' },
    { value: '生物医药和先进医疗装备' },
    { value: '精细化工' },
    { value: '节能环保' },
    { value: '软件和信息技术服务' },
    { value: '高品质钢铁材料' },
    { value: '其他' }
];

// 若需要保留默认导出（兼容其他导入场景），可追加：
export default {
    IMG_BASE_URL,
    IMG_GET_URL,
    PLATFORM_TITLE,
    tech_demand_options
};